var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0217 0.803384C16.5783 0.360051 15.9833 0.115051 15.365 0.115051H2.33333C1.03833 0.115051 0 1.16505 0 2.44838V18.7817C0 20.0651 1.05 21.1151 2.33333 21.1151H18.6667C19.95 21.1151 21 20.0651 21 18.7817V5.75005C21 5.13172 20.755 4.53672 20.3117 4.10505L17.0217 0.803384ZM10.5 18.7817C8.56333 18.7817 7 17.2184 7 15.2817C7 13.3451 8.56333 11.7817 10.5 11.7817C12.4367 11.7817 14 13.3451 14 15.2817C14 17.2184 12.4367 18.7817 10.5 18.7817ZM11.6667 7.11505H4.66667C3.38333 7.11505 2.33333 6.06505 2.33333 4.78172C2.33333 3.49838 3.38333 2.44838 4.66667 2.44838H11.6667C12.95 2.44838 14 3.49838 14 4.78172C14 6.06505 12.95 7.11505 11.6667 7.11505Z",
    fill: "#2BACE2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.23aebb00077757be2d675598ae48f42d.svg";
export { ForwardRef as ReactComponent };